import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { TruffleDialogTitle } from "../../../MuiComponents";
const resizeHandleBackground = require("../../../Assets/resize.svg");
const dialogPaperSxProps = {
    resize: "both",
    minWidth: "600px",
    minHeight: "363px",
    maxWidth: "unset",
    // Style resize handle
    "::-webkit-resizer": {
        display: "none"
    },
    "&::after": {
        content: "\"\"",
        position: "absolute",
        right: "2px",
        bottom: "2px",
        width: "12px",
        height: "12px",
        backgroundImage: `url(${resizeHandleBackground})`,
        backgroundSize: "cover"
    }
};
export const RichTextDialog = ({ open, onClose, onSave, title, children }) => {
    return (_jsxs(Dialog, { open: open, PaperProps: { sx: dialogPaperSxProps }, sx: { "& .ql-editor": { minWidth: "536px", minHeight: "192px" } }, children: [_jsx(TruffleDialogTitle, { CloseIconButtonProps: { onClick: onClose }, children: title }), _jsx(DialogContent, { children: children }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancel" }), _jsx(Button, { onClick: onSave, variant: "contained", children: "Save" })] })] }));
};
//# sourceMappingURL=RichTextDialog.js.map